import { tv } from 'tailwind-variants'

export const selectOptionStyles = tv({
  base: 'px-4 py-3 ml-7 border border-gray-300 transition-colors duration-300 cursor-pointer',
  variants: {
    selected: {
      true: 'bg-gray-100',
      false: 'bg-white'
    },
    disabled: {
      true: 'pointer-events-none'
    },
    first: {
      true: 'rounded-t-lg'
    },
    last: {
      true: 'rounded-b-lg',
      false: 'border-b-0'
    },
    hoverable: {
      true: 'hover:bg-gray-100'
    }
  },
  defaultVariants: {
    selected: false,
    disabled: false,
    first: false,
    last: false,
    hoverable: false
  }
})
